<template>
  <div class="report-view report-summary-information">
    <div class="report-head">
      <div class="report-num">
        <p>Форма № учёт-ондатр</p>
      </div>
      <div class="report-agreed">
        <p><strong>"Согласовано"</strong></p>
        <p>____________________________________</p>
        <p>____________________________________</p>
        <p><span>"______"____________ 20__ год</span></p>
      </div>
      <h5 class="text-center">Сводные сведения по численности ондатр
        на начало {{ year }} года
        <label v-if="oopt"><u>{{ oopt }}</u>
          <span class="sm-hint">наименование охотпользователя  (региональных управлений Главохоты)</span>
        </label>
      </h5>
    </div>
    <!-- report-body -->
    <div class="report-body">
      <div class="table-overflow">
        <table class="table-full">
          <thead>
          <tr>
            <td rowspan="2">{{ $t('Наименование') }}</td>
            <td colspan="3">{{ $t('Учтено') }}</td>
            <td colspan="2">{{ $t('Установлено') }}</td>
          </tr>
          <tr>
            <td>{{ $t('нор') }}</td>
            <td>{{ $t('хаток') }}</td>
            <td>{{ $t('всего') }}</td>
            <td>{{ $t('приплод') }}</td>
            <td>{{ $t('запас') }}</td>
          </tr>
          </thead>
          <tbody>
          <template v-if="reportData.resultData">
            <tr v-for="item in reportData.resultData">
              <td>{{ item.name }}</td>
              <td class="text-center">{{ item.burrowOndatraAccountedSum }}</td>
              <td class="text-center">{{ item.hutsOndatraAccountedSum }}</td>
              <td class="text-center">{{ item.totalOndatraAccountedSum }}</td>
              <td class="text-center">{{ item.offspringOndatraEstablishedSum }}</td>
              <td class="text-center">{{ item.stockOndatraEstablishedSum }}</td>
            </tr>
          </template>
          <template v-if="reportData.total">
            <tr>
              <td><b>{{ $t('Итого') }}:</b></td>
              <td class="text-center"><b>{{ reportData.total.burrowOndatraAccountedSum }}</b></td>
              <td class="text-center"><b>{{ reportData.total.hutsOndatraAccountedSum }}</b></td>
              <td class="text-center"><b>{{ reportData.total.totalOndatraAccountedSum }}</b></td>
              <td class="text-center"><b>{{ reportData.total.offspringOndatraEstablishedSum }}</b></td>
              <td class="text-center"><b>{{ reportData.total.stockOndatraEstablishedSum }}</b></td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="report-footer">
      <div class="report-footer-item">
        <div class="flexbox">
          <div>М.П. <span>_____________________________________</span></div>
          <div><span>_____________________</span>20____г.</div>
        </div>
      </div>
      <div class="report-footer-item">
        <div class="report-footer-row">
          <div class="col-md-6 report-user-data">
            <div class="flexbox report-item-child">
              <div class="mleft-7">Ф.И.О.,  должность составителя</div>
              <div class="mleft-7">подпись дата</div>
            </div>
            <div class="flexbox">
              <div>
                <p>Присутствовал: <span>__________________</span>
                  <br>работник Департамента охоты Ф.И.О., должность</p>
              </div>
              <div>
                <p>
                  <span>___________</span> 20____г. <br>подпись дата
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6 report-user-check">
            <h6><strong>"Проверено"</strong></h6>
            <div>
              <p>Руководитель <span>___________________________</span> Представительства</p>
            </div>
            <div>Департамента охотничьего надзора и регулирования численности охотничьих ресурсов</div>
            <div class="flexbox">
              <div class="mleft-7">
                <p><span>_________</span> <br>подпись</p>
              </div>
              <div class="mleft-7">
                <p><span>____________________</span> <br>Ф.И.О.</p>
              </div>
            </div>
            <div>
              <p>
                <span>"______"</span> <span>____________</span> 20___год
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    reportData: Object,
    year: String,
    oopt: String
  }
}
</script>

<style scoped>

</style>
